import React from 'react';
import { createStyles, makeStyles } from '@material-ui/core';
import { InvertColors } from '@material-ui/icons';
import IconButton from '@material-ui/core/IconButton';
import { useMultipleSelectionContext } from '../staff/MultipleStaffShiftSelection';
import PopupColorSelectMenu from '../shared/PopupColorSelectMenu';

const ColorSelector = () => {
  const classes = useStyles();
  const { addColor, deselectAll } = useMultipleSelectionContext();

  const handleSelect = async (nextColor: string | null) => {
    try {
      await addColor(nextColor);
      deselectAll();
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <div className={classes.wrapper}>
      <PopupColorSelectMenu
        editable
        onSelect={handleSelect}
        renderTrigger={({ onClick }) => (
          <IconButton size="small" onClick={onClick}>
            <InvertColors style={{ color: 'inherit' }} />
          </IconButton>
        )}
      />
    </div>
  );
};

const useStyles = makeStyles(theme =>
  createStyles({
    wrapper: {
      display: 'flex',
      alignItems: 'center',
    },
  })
);

export default ColorSelector;
